export default "__VITE_ASSET__3MviCKoD__"